export class SampleRequestScreenModel {
    /** 商品IDs（|1|3|4|） */
    productIds: string | null = null;
}
